// Login
export const START_LOGIN = 'START_LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const RESET_LOGIN_STATUS = 'RESET_LOGIN_STATUS';

// Logout
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';